import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild } from '@angular/core';
import { simplifySpecialCharacters } from '../../utils/simplifySpecialCharacters';

@Component({
  selector: 'app-tag-list-input',
  templateUrl: './tag-list-input.component.html',
  styleUrls: ['./tag-list-input.component.scss']
})
export class TagListInputComponent implements OnInit {
  @Input() availableTags: {tag: string, count: number}[] = [];
  @Input() startValues: {tag: string, count: number}[] = [];
  @Output() tagChange = new EventEmitter<{tag: string, count: number}[]>();

  public filteredList: {tag: string, count: number}[] = [];
  public selectList: {tag: string, count: number}[] = [];
  public showOptions = false;
  public tagDropdownWidth = this.getTagDropdownWidth();

  @ViewChild('optionListGroup', { static: true }) optionListGroup;
  @ViewChild('input', { static: true }) input;

  constructor() { }

  ngOnInit() {
    if (this.startValues) {
      if (!(this.startValues instanceof Array)) {
        throw new Error("Start values should be an array")
      }
    }
    if (!(this.availableTags instanceof Array)) {
      throw new Error("Invalid tag list");
    }
    this.selectList = this.selectList.concat(this.startValues);
    console.log(this.availableTags);

    this.updateFilteredList();
  }

  onSelectOption(option: {tag: string, count: number}) {
    this.selectList.push(option);
    this.tagChange.emit(this.selectList);
    this.updateFilteredList();
  }

  onRemoveSelected(option: {tag: string, count: number}) {
    if (this.selectList.includes(option)) {
      this.selectList.splice(this.selectList.indexOf(option), 1);
    }
    this.tagChange.emit(this.selectList);
    this.updateFilteredList();
  }

  getTagDropdownWidth() {
    if (this.optionListGroup && this.optionListGroup.nativeElement) {
      const el = this.optionListGroup.nativeElement.querySelector(".option-list-wrapper");
      if (el) {
        return el.getBoundingClientRect().width - 2;
      }
    }
    return 240;
  }

  onInputFocus(isFocused: boolean) {
    if (isFocused) {
      const width = this.getTagDropdownWidth();
      if (this.tagDropdownWidth !== width) {
        this.tagDropdownWidth = width;
      }
    }
    this.showOptions = isFocused;
  }

  updateFilteredList() {
    const value = simplifySpecialCharacters(this.input.nativeElement.value.trim().toLowerCase());

    this.filteredList = this.availableTags.filter((tagObj) => {
      if (this.selectList.includes(tagObj)) {
        return false;
      }
      let hasTag = false;
      for (let tag of this.selectList) {
        if (tag.tag === tagObj.tag) {
          hasTag = true;
          break;
        }
      }
      if (hasTag) {
        return false;
      }
      if (simplifySpecialCharacters(tagObj.tag).toLowerCase().includes(value)) {
        return true;
      }
      return false;
    }).filter((tag, i) => i < 5).sort((a, b) => b.count - a.count);
  }

  onInputChange() {
    this.updateFilteredList();
  }

  // Detect FocusOut via global click so that options don't dissapear on click
  @HostListener('window:click', ['$event'])
  onWindowClick(event) {
    if (this.showOptions && this.optionListGroup && this.optionListGroup.nativeElement) {
      if (this.input && this.input.nativeElement && document.activeElement === this.input.nativeElement) {
        return true;
      }
      let hasGroup = false;
      for (const element of event.composedPath()) {
        if (element && element.classList && element.classList.contains('option-list-group')) {
          hasGroup = true;
        }
      }
      if (!hasGroup) {
        this.onInputFocus(false);
      }
    }
  }

}
